import { render } from "./users.vue?vue&type=template&id=51c48395"
import script from "./users.vue?vue&type=script&lang=ts"
export * from "./users.vue?vue&type=script&lang=ts"
script.render = render

export default script